import React from "react";

import CaseStudyCard from "./CaseStudyCard";
import { caseStudyData } from "./caseData.js";

const CaseStudyText = ({ data }) => {
  return (
    <div>
      {data?.map((v, i) => {
        return (
          <CaseStudyCard
            key={v.id}
            index={i}
            title={v.title}
            id={v.id}
            machine={v.machine}
            Improved={v.improved_process}
            previuos={v.previous_process}
            wirediameter={v.wire_diameter}
            matrial={v.material}
          />
        );
      })}
    </div>
  );
};

export default CaseStudyText;
